import PropTypes from "prop-types";
import { generatePosterUrl } from "../CategoryHeaderVideo/generatePosterUrl";
import styles from "./index.css";

const CategoryHeaderImage = ({ viewportCategory, mediaUrls }) => (
  <div className={styles.categoryHeaderImage}>
    <img
      className={styles.image}
      src={generatePosterUrl(viewportCategory, mediaUrls)}
      alt=""
    />
  </div>
);

CategoryHeaderImage.propTypes = {
  viewportCategory: PropTypes.string.isRequired,
  mediaUrls: PropTypes.shape({
    mobile: PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      videoUrl: PropTypes.string.isRequired
    }).isRequired,
    desktop: PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      videoUrl: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default CategoryHeaderImage;
